<div class="version-page-container" *ngIf="!isLoadingPage">
	<div class="version title">
		<span class="message">
			{{ labels.lbl_termo_responsabilidade_assinado_enviado }}<br /><br />
			{{ labels.lbl_caso_deseje_baixar_termo }},
			<a (click)="downloadPDF()" class="download-link">{{ labels.lbl_geral_clique_aqui }}</a
			>.
		</span>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingPage">
	<cpi-svg-gears></cpi-svg-gears>
	<img class="blue-satisfaction-ball" src="assets/images/BolinhaAzul.svg" />
	<img class="orange-satisfaction-ball" src="assets/images/BolinhaRosa.svg" />
</div>

<img class="blue-satisfaction-ball" src="assets/images/BolinhaAzul.svg" />
<img class="orange-satisfaction-ball" src="assets/images/BolinhaRosa.svg" />
